import { Button, type ButtonProps } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"

export const DataFlowButton = ({ type: _, ...props }: ButtonProps) => {
  const { t } = useTranslation()
  const { loading } = props
  const tKey = `triage.drawer.dataFlow.${loading ? "preparingDataFlow" : "investigateDataFlow"}`
  const type = loading ? "text" : "link"

  return (
    <Button size="small" type={type} {...props}>
      {t(tKey)}
    </Button>
  )
}
